module.exports = __webpack_public_path__ + "img/mds_screenshotask.a575c145.png";